import {createContext} from 'react';

export const SDKContext = createContext({}); 